import React from 'react'
import { observer, inject } from 'mobx-react'

import { BoxCenter } from '../../../generic/Box'
import Title from '../../../generic/Title'
import Loader from '../../../generic/Loader'

const ReinfPeriodStatus = inject('reinfStore')(observer(props => {
  const { reinfStore } = props
  const { isFetching, status, date } = reinfStore.state.periodStatus
  const dateString = date ? date.toLocaleString('pt-br') : null
  return (
    <BoxCenter>
      <Title>Status do período</Title>
      <Loader isLoading={isFetching}>
        <div>{status}</div>
        <div>{dateString}</div>
      </Loader>
    </BoxCenter>
  )
}))

export default ReinfPeriodStatus



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4reinf/ReinfPeriodStatus.js